export default {"src":"/_next/static/media/why-3.4fa91bcf.svg","height":32,"width":33};